export type ProviderType = 'GP' | 'HOSPITAL' | 'PAGINATOR';

export interface ProviderOption {
  providerOptionName: string;
  providerOptionType: ProviderType;
}

export const PROVIDER_TYPE_OPTIONS: ProviderOption[] = [
  { providerOptionName: 'GP', providerOptionType: 'GP' },
  { providerOptionName: 'Hospital', providerOptionType: 'HOSPITAL' },
  { providerOptionName: 'Paginator', providerOptionType: 'PAGINATOR' },
];
